import Card from '@mui/material/Card';
import Collapse from '@mui/material/Collapse';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';
import { CountryCode } from 'libphonenumber-js';
import { ControllerProps, FieldErrors } from 'react-hook-form';

import { CheckBoxFormField } from '~components/FormFields/CheckBoxFormField';
import { PhoneCodeFlagInput } from '~components/FormFields/PhoneCodeFlagInput';
import { TextFormField } from '~components/FormFields/TextFormField';

interface Props {
  control: any;
  errors: any;
  selectedCountry: any;
  isBillingContactHidden: boolean;
  selectedBillingCountry: any;
}

const AccountContact = ({
  control,
  errors,
  selectedCountry,
  isBillingContactHidden,
  selectedBillingCountry,
}: Props) => (
  <Card sx={{ p: 2, mb: 2, overflow: 'visible' }}>
    {/*Account contact*/}
    <Typography variant="form-section-title" sx={{ mb: 2 }}>
      {t('account.form.contact_information')}
    </Typography>
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <TextFormField
          control={control}
          errors={errors}
          name="primaryContact.name"
          label={`${t('form_fields.name')}`}
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <TextFormField
          control={control}
          errors={errors}
          name="primaryContact.email"
          label={`${t('form_fields.email')}`}
          sx={{ mr: 2 }}
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <PhoneCodeFlagInput
          control={control as unknown as ControllerProps['control']}
          errors={errors as unknown as FieldErrors}
          name="primaryContact.phone"
          label={`${t('form_fields.phone')}`}
          defaultCountryCode={
            selectedCountry && selectedCountry.code
              ? (selectedCountry.code as CountryCode)
              : undefined
          }
        />
      </Grid>
    </Grid>

    <CheckBoxFormField
      control={control}
      errors={errors}
      value={false}
      label={t('account.form.billing_contact_same_as_primary') || ''}
      name={'isBillingContactSame'}
    />

    <Collapse in={!isBillingContactHidden}>
      <Typography variant="form-section-title" sx={{ mb: 2 }}>
        {t('account.form.billing_contact')}
      </Typography>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12 }}>
          <TextFormField
            control={control}
            errors={errors}
            name="billingContact.name"
            label={`${t('form_fields.name')}`}
          />
        </Grid>
        <Grid size={{ xs: 6 }}>
          <TextFormField
            control={control}
            errors={errors}
            name="billingContact.email"
            label={`${t('form_fields.email')}`}
            sx={{ mr: 2 }}
          />
        </Grid>
        <Grid size={{ xs: 6 }}>
          <PhoneCodeFlagInput
            control={control as unknown as ControllerProps['control']}
            errors={errors as unknown as FieldErrors}
            name="billingContact.phone"
            label={`${t('form_fields.phone')}`}
            defaultCountryCode={
              selectedBillingCountry && selectedBillingCountry.code
                ? (selectedBillingCountry.code as CountryCode)
                : undefined
            }
          />
        </Grid>
      </Grid>
    </Collapse>
  </Card>
);

export { AccountContact };
